import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  update: { updating: false, success: false },
  data: [],
  loading: false,
  error: null,
};
const corporateSlice = createSlice({
  name: "corporate",
  initialState,
  reducers: {
    fetchCorporateListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCorporateListSuccess(state, action) {
      state.data = action.payload.data;
      state.loading = false;
    },
    fetchCorporateListFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchCompanyIdRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCompanyIdSuccess(state, action) {
      state.Iddata = action.payload.data;
      state.loading = false;
    },
    fetchCompanyIdFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    addCorporateRequest(state) {
      state.update = { updating: true, success: false };
    },
    addCorporateSuccess(state: any, action) {
      state.update = { updating: false, success: true };
    },
    addCorporateFailure(state, action) {
      state.update = { updating: false, success: false };
    },
    resetUpdateState(state) {
      state.update = { creating: false, success: false };
    },
    editEnterprisesRequest(state) {
      state.update = { updating: true, success: false };
    },
    editEnterprisesSuccess(state: any, action) {
      state.update = { updating: false, success: true };
    },
    editEnterprisesFailure(state, action) {
      state.update = { updating: false, success: false };
    },
  },
});
export const {
  fetchCorporateListRequest,
  fetchCorporateListSuccess,
  fetchCorporateListFailure,
  fetchCompanyIdRequest,
  fetchCompanyIdSuccess,
  fetchCompanyIdFailure,
  addCorporateRequest,
  addCorporateSuccess,
  addCorporateFailure,
  resetUpdateState,
  editEnterprisesRequest,
  editEnterprisesSuccess,
  editEnterprisesFailure,
} = corporateSlice.actions;
export default corporateSlice.reducer;
